import styled, { css } from "styled-components";
import { colors } from "../../../../../../../../consts";

import { WrapperContainer } from "../../../../../../../../components";
import { OptionButton } from "../../../../../../../../components/DropdownOptions/styled";

const ActiveInputStyles = css`
  input {
    background: ${colors.RAISIN_20};
  }
`;

export const LogsTableDropdownWrapper = styled(WrapperContainer)`
  width: 134px;

  input {
    height: 32px;
    border: none;
    outline: none;
  }

  .active {
    ${ActiveInputStyles}
  }

  &:hover {
    ${ActiveInputStyles}
  }

  ${OptionButton} {
    height: 32px;
    min-height: 32px;
    max-height: 32px;
  }
`;
